import CloseCardWithdrawalAsset from './CloseCardWithdrawalAsset';

export default CloseCardWithdrawalAsset;
